import { render, staticRenderFns } from "./UserDeleteButton.vue?vue&type=template&id=324739b0&"
import script from "./UserDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./UserDeleteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports